// LOAD ALL THE READ ONLY DATA
import { makeSetReducer } from "./utils";

export const tipoDevolucionesFullfilledReducer = makeSetReducer(['tipo_devoluciones/fullfilled']);
